
import {  GET_ALL_HOTSPOT_VIIRS_ERROR, GET_ALL_HOTSPOT_VIIRS_POST_ERROR,  GET_ALL_VIIRS_SUCCESS} from "../actions/types";

export default (state = {  
    error: null,
    results:[],
    success:false,
}, action) => {
    switch (action.type) {
        case GET_ALL_HOTSPOT_VIIRS_ERROR:
            return {
                ...state,
                error: state.error,
                loading:false,
                success: false,
                isSnackbarError: true,
                isSwitchSnackbarOn: true,
                ErrorMessage: action.payload.message,
            };
            break; 
            case GET_ALL_VIIRS_SUCCESS:
                return {
                    ...state,
                    error: state.error,
                    loading:false, 
                    success:true,
                    results:action.payload,
                    isSnackbarError: false,
                    isSwitchSnackbarOn: true,
                    ErrorMessage: 'VIIRS retrieved successfully',
                };
                break;
            
        case GET_ALL_HOTSPOT_VIIRS_POST_ERROR:
            return {
                ...state,
                error: state.error,
                loading:false,
                success: false,
                isSnackbarError: false,
                isSwitchSnackbarOn: true,
                ErrorMessage: 'Retrieve Error | ' + state.error,
            };
            break;
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/hotspotRawVIIRSreducer.js